import React from "react";
import { Card, Typography, Box } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { green } from "@mui/material/colors";

const DocumentsListCard = ({ documents, heading }) => {
  return (
    <Card
      sx={{
        p: 2,
        border: "1px solid #E6E6E6",
        backgroundColor: "#fff",
        width: "100%",
      }}
    >
      <Typography className="sub-header" fontWeight="600" mb={2}>
        {heading}
      </Typography>

      {documents.map((doc) => (
        <Card
          key={doc.id}
          sx={{
            p: 2,
            mb: 1,
            border: "1px solid #E6E6E6",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <img src="/icons/doc-icon.svg" alt="doc=icon" width="" height="" />
            <Box>
              <Typography variant="body2" fontWeight="500">
                {doc.name}
              </Typography>
              {/* <Typography variant="caption" color="textSecondary">
                {doc.size} • {doc.date}
              </Typography> */}
            </Box>
          </Box>
          <Box textAlign="right" display="flex" gap={1.5} alignItems="center">
            {/* Category pill */}
            <Box
              sx={{
                bgcolor: "#f0f0f0",
                color: "black",
                px: 1.6,
                py: 0.6,
                borderRadius: "999px",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 500 }}>
                {doc.category}
              </Typography>
            </Box>

            {/* Status with icon */}
            <Typography
              variant="caption"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <CheckCircleOutlineIcon
                sx={{ color: green[500], fontSize: 16 }}
              />
              {doc.status}
            </Typography>
          </Box>
        </Card>
      ))}
    </Card>
  );
};

export default DocumentsListCard;
